import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Landing from '@/pages/Landing';
import Privacy from '@/pages/Privacy';
import DeleteAccount from '@/pages/DeleteAccount';
import IosSoon from '@/pages/IosSoon';
import CookieBar from '@/components/CookieBar';
import { useLocaleSync } from '@shared/ui/useLocaleSync.js';
import { api } from '@/api';

export default function App() {
  // Same as the app: registration already carries the locale, but a language
  // switch afterwards has to reach the record too.
  useLocaleSync(api);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/privacy" element={<Privacy />} />
        {/* Google Play requires this reachable without signing in — it is the
            account deletion URL on the store listing. */}
        <Route path="/delete-account" element={<DeleteAccount />} />
        {/* Every App Store button leads here while the iOS app is in review. */}
        <Route path="/ios" element={<IosSoon />} />
        {/* nginx serves index.html for unknown paths; send them to the landing
            page rather than rendering a blank router outlet. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <CookieBar />
    </BrowserRouter>
  );
}
